import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import "./abstract-base-8edf0a84-e11d45a3.js";
import { e as g } from "./state-b4c9cc73-ee633f6c.js";
import { s as b } from "./lifecycle-decorators-ecc4e836-92da4b80.js";
import { l as E, o as w, i as S } from "./helper-dd9a664c-e404f685.js";
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var N = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"],
  I = /* @__PURE__ */N.join(","),
  v = typeof Element > "u",
  d = v ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
  f = !v && Element.prototype.getRootNode ? function (e) {
    var n;
    return e == null || (n = e.getRootNode) === null || n === void 0 ? void 0 : n.call(e);
  } : function (e) {
    return e == null ? void 0 : e.ownerDocument;
  },
  A = function e(n, t) {
    var r;
    t === void 0 && (t = !0);
    var o = n == null || (r = n.getAttribute) === null || r === void 0 ? void 0 : r.call(n, "inert"),
      i = o === "" || o === "true",
      u = i || t && n && e(n.parentNode);
    return u;
  },
  D = function D(e) {
    var n,
      t = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
    return t === "" || t === "true";
  },
  T = function T(e) {
    return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
  },
  x = function x(e) {
    if (!e) throw new Error("No node provided");
    return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || D(e)) && !T(e) ? 0 : e.tabIndex;
  },
  y = function y(e) {
    return e.tagName === "INPUT";
  },
  C = function C(e) {
    return y(e) && e.type === "hidden";
  },
  F = function F(e) {
    var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function (t) {
      return t.tagName === "SUMMARY";
    });
    return n;
  },
  R = function R(e, n) {
    for (var t = 0; t < e.length; t++) if (e[t].checked && e[t].form === n) return e[t];
  },
  k = function k(e) {
    if (!e.name) return !0;
    var n = e.form || f(e),
      t = function t(i) {
        return n.querySelectorAll('input[type="radio"][name="' + i + '"]');
      },
      r;
    if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") r = t(window.CSS.escape(e.name));else try {
      r = t(e.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
    var o = R(r, e.form);
    return !o || o === e;
  },
  L = function L(e) {
    return y(e) && e.type === "radio";
  },
  O = function O(e) {
    return L(e) && !k(e);
  },
  U = function U(e) {
    var n,
      t = e && f(e),
      r = (n = t) === null || n === void 0 ? void 0 : n.host,
      o = !1;
    if (t && t !== e) {
      var i, u, a;
      for (o = !!((i = r) !== null && i !== void 0 && (u = i.ownerDocument) !== null && u !== void 0 && u.contains(r) || e != null && (a = e.ownerDocument) !== null && a !== void 0 && a.contains(e)); !o && r;) {
        var l, c, p;
        t = f(r), r = (l = t) === null || l === void 0 ? void 0 : l.host, o = !!((c = r) !== null && c !== void 0 && (p = c.ownerDocument) !== null && p !== void 0 && p.contains(r));
      }
    }
    return o;
  },
  h = function h(e) {
    var n = e.getBoundingClientRect(),
      t = n.width,
      r = n.height;
    return t === 0 && r === 0;
  },
  M = function M(e, n) {
    var t = n.displayCheck,
      r = n.getShadowRoot;
    if (getComputedStyle(e).visibility === "hidden") return !0;
    var o = d.call(e, "details>summary:first-of-type"),
      i = o ? e.parentElement : e;
    if (d.call(i, "details:not([open]) *")) return !0;
    if (!t || t === "full" || t === "legacy-full") {
      if (typeof r == "function") {
        for (var u = e; e;) {
          var a = e.parentElement,
            l = f(e);
          if (a && !a.shadowRoot && r(a) === !0) return h(e);
          e.assignedSlot ? e = e.assignedSlot : !a && l !== e.ownerDocument ? e = l.host : e = a;
        }
        e = u;
      }
      if (U(e)) return !e.getClientRects().length;
      if (t !== "legacy-full") return !0;
    } else if (t === "non-zero-area") return h(e);
    return !1;
  },
  P = function P(e) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName)) for (var n = e.parentElement; n;) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var t = 0; t < n.children.length; t++) {
          var r = n.children.item(t);
          if (r.tagName === "LEGEND") return d.call(n, "fieldset[disabled] *") ? !0 : !r.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
    return !1;
  },
  j = function j(e, n) {
    return !(n.disabled ||
    // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    A(n) || C(n) || M(n, e) ||
    // For a details element with a summary, the summary element gets the focus
    F(n) || P(n));
  },
  B = function B(e, n) {
    return !(O(n) || x(n) < 0 || !j(e, n));
  },
  s = function s(e, n) {
    if (n = n || {}, !e) throw new Error("No node provided");
    return d.call(e, I) === !1 ? !1 : B(n, e);
  },
  K = Object.defineProperty,
  q = Object.getOwnPropertyDescriptor,
  m = function m(e, n, t, r) {
    for (var o = r > 1 ? void 0 : r ? q(n, t) : n, i = e.length - 1, u; i >= 0; i--) (u = e[i]) && (o = (r ? u(n, t, o) : u(o)) || o);
    return r && o && K(n, t, o), o;
  };
var G = function G() {
  return function (e) {
    var n = /*#__PURE__*/function (_e) {
      _inherits(n, _e);
      function n() {
        var _this;
        _classCallCheck(this, n);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(n).apply(this, arguments)), _this.currentFocusIndex = 0;
        return _this;
      }
      /**
       * This is a Depth First Traversal function used to collect an ordered array of tabbable elements within a bounding parent element.
       * @param rootNode parent HTMLElement that functions as the "bounds" of this function.
       * @returns an ordered array of tabbable HTMLElements that are children or descendants of the shadowRoot of the rootNode.
       */
      _createClass(n, [{
        key: "findTabbableElements",
        value: function findTabbableElements(r) {
          var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : s;
          var i;
          var u = [r],
            a = [];
          for (; u.length;) {
            var l = u.pop();
            l && (o(l) && a.push(l), l.childElementCount && Array.from(l.children).reverse().forEach(function (c) {
              return u.push(c);
            }), (i = l.shadowRoot) != null && i.childElementCount && Array.from(l.shadowRoot.children).reverse().forEach(function (c) {
              return u.push(c);
            }));
          }
          return a;
        }
        /**
         * function for handling tabbed focussing within an ordered array of focus-trapped HTMLElements.
         * @param event 'Tab' or 'Shift-Tab' Keyboard event that functions as trigger for toggling focus among focus-trapped HTMLElements
         * @param trappingElement parent HTMLElement that functions as the "bounds" of the focus-trap.
         * @param hasTabbableCriteria boolean indicating if the element is navigable with keys
         */
      }, {
        key: "handleFocusTabbing",
        value: function handleFocusTabbing(r, o) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : s;
          return this.handleFocus(r, o, E, i);
        }
        /**
         * function for handling arrow key focussing within an ordered array of focus-trapped elements
         * @param event 'Left', 'Right', 'Up' or 'Down' Keyboard events that trigger focus trapping among focus-trapped elements
         * @param trappingElement parent HTMLElement that functions as the "bounds" of the focus-trap.
         * @param hasTabbableCriteria boolean indicating if the element is navigable with keys
         * @returns the focus handler taking key based parameters
         */
      }, {
        key: "handleFocusArrowKeys",
        value: function handleFocusArrowKeys(r, o) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : s;
          return this.handleFocus(r, o, w, i);
        }
        /**
         * function that focuses the next focusable element within the focus trap based on the passed incrementing function
         * @param event the key event triggering the focus change
         * @param trappingElement parent HTMLElement that functions as the "bounds" of the focus-trap.
         * @param incrementingFunc function that takes a key and a boolean indicating whether shift has been pressed and returns a number to increment by
         * @param hasTabbableCriteria boolean indicating if the element is navigable with keys
         * @returns a number indicating which branch was followed for testing purposes
         */
      }, {
        key: "handleFocus",
        value: function handleFocus(r, o, i) {
          var u = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : s;
          if (r && o) {
            r.preventDefault();
            var a = this.findTabbableElements(o, u),
              l = a.length;
            if (a.length === 0) return 0;
            var c = i(r.key, r.shiftKey);
            return this.currentFocusIndex = S(this.currentFocusIndex, c, l), a[this.currentFocusIndex].focus(), 1;
          }
          return 3;
        }
      }]);
      return n;
    }(e);
    return m([g()], n.prototype, "currentFocusIndex", 2), n = m([b("FocusTrap")], n), n;
  };
};
export { G as X };